import { render, staticRenderFns } from "./ItineraryDetails.vue?vue&type=template&id=50281efe"
import script from "./ItineraryDetails.vue?vue&type=script&lang=js"
export * from "./ItineraryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports